<template>
	<div class="multi-flex">
		<label id="hideinmobile" v-if="!noLabel" class="teams-label-font mt-1 w-12">
			<div>{{ label }}<span v-if="mandatory" class="asterik">*</span></div>
			<div v-if="mandatory && id == 'responsibility'" class="asp-topic">
				( Min 1 required )
			</div>
		</label>
		<label id="hideinlaptop" class="mul-grey-txt"
			>{{ label }} 
			<span v-if="mandatory"><span class="asterik">*</span> ( Min 1 required) </span>
		</label>
		<main class="w-100 d-flex flex-column gap-2">
			<div
				class="mobml-0"
				:class="formID == 'personalDetails' ? 'ml-5' : 'ml-4'"
				v-for="(input, index) in inputData"
				:key="index"
			>
				<div class="d-flex position-relative">
					<input
						v-if="inputData[index].length < 102"
						type="text"
						v-model.trim="inputData[index]"
						:id="id"
						:placeholder="placeholder"
						@input="handleInput(index)"
						class="w-95 laptopinput mul-input-height"
						@focus="isFocused = true"
						:class="{
							error:
								errorStates[index] ||
								errorStatesLen[index] ||
								(showError && id != 'portfolio' && errorStates[index]),
						}"
						:autofocus="isFocused && inputData[index].length < 102"
						:maxlength="id === 'portfolio' ? null : limit"
					/>
					<b-form-textarea
						v-else
						v-model="inputData[index]"
						:class="
							errorStates[index] || errorStatesLen[index]
								? 'candash-textarea-error'
								: 'candash-textarea'
						"
						type="text"
						:placeholder="placeholder"
						rows="2"
						max-rows="4"
						:autofocus="isFocused && inputData[index].length > 1"
						@input="handleHighInput(index)"
						:maxlength="id === 'portfolio' ? null : limit"
					></b-form-textarea>
					<img
						v-if="inputData[index] == true || inputData[index].length === 0"
						class="candash-action"
						src="@/assets/New Profile/disabled-add.svg"
						alt=""
					/>
					<img
						v-else-if="
							(index === inputData.length - 1 &&
								id == 'portfolio' &&
								inputData.length < 7) ||
							(index === inputData.length - 1 && id != 'portfolio')
						"
						@click="addInput"
						class="pointer candash-action"
						src="@/assets/newdesign/dashboard/blueRoundAdd.svg"
						alt=""
					/>
					<img
						v-else
						@click="removeInput(index)"
						class="pointer candash-action"
						src="@/assets/newdesign/dashboard/blueBin.svg"
						alt=""
					/>
				</div>
				<div
					v-if="inputData[index].length > 0 && id != 'portfolio'"
					class="candash-character-left mt-1"
				>
					{{ limit - inputData[index].length }} characters left
				</div>
				<div
					v-else-if="
						errorStatesLen[index] && id == 'portfolio' && triggerLinkValid
					"
					class="newInt-required-validation-font mt-1"
				>
					Exceeded the max char length of {{ limit }}
				</div>
				<div
					v-else-if="
						errorStates[index] && id == 'portfolio' && triggerLinkValid
					"
					class="newInt-required-validation-font mt-1"
				>
					Enter Valid Link
				</div>
				<!-- <div
					v-else-if="
						errorStates[index] &&
						id == 'highlight' &&
						inputData.every((value) => value === '')
					"
					class="newInt-required-validation-font mt-1"
				>
					Required
				</div> -->
			</div>
		</main>
	</div>
</template>

<script>
import { showError } from "@/utils/customField";

export default {
	name: "MultipleInput",
	data() {
		return {
			inputData: [""],
			errorStates: [false],
			errorStatesLen: [false],
			isFocused: false,
			currentIndex: null,
			triggerLinkValid: false,
		};
	},
	props: {
		noLabel: Boolean,
		disabled: Boolean,
		mandatory: Boolean,
		showError: Boolean,
		type: String,
		label: String,
		placeholder: String,
		id: String,
		formID: String,
		fieldType: String,
		vmodel: {
			validator: function () {
				return true;
			},
		},
		fieldVal: Object,
		limit: Number,
	},
	created() {
		if (this.vmodel && this.vmodel.length > 0) {
			this.inputData = this.vmodel;
			this.errorStates = this.vmodel.map(() => false);
			this.errorStatesLen = this.vmodel.map(() => false);
			this.$emit("select-value", this.inputData);
		}
	},

	watch: {
		vmodel(value) {
			if (value == undefined || value.length === 0) {
				this.inputData = [""];
				this.errorStates = [false];
				this.errorStatesLen = [false];
			} else if (value.length > 0) {
				this.inputData = value;
				// this.errorStates = value.map(() => false);
				this.$emit("select-value", this.inputData);
			}
		},
		inputData(val) {
			this.checkValid(val);
		},
		showError(val) {
			if (val == true) {
				this.checkValid(this.inputData);
			}
		},
	},

	methods: {
		checkValid(vals) {
			if (this.id != "portfolio") {
				for (let i = 0; i < vals.length; i++) {
					if (
						vals[i].length > this.fieldVal.limit ||
						(vals && vals.every((val) => val === ""))
					) {
						this.errorStates[i] = true;
					} else {
						this.errorStates[i] = false;
					}
				}
			} else if (this.id == "portfolio") {
				const urlPattern =
					/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
				for (let i = 0; i < vals.length; i++) {
					if (
						this.inputData[i].trim() != "" &&
						!urlPattern.test(this.inputData[i].trim())
					) {
						this.errorStatesLen[i] = false;
						this.errorStates[i] = true;
						this.triggerLinkValid = true;
					} else if (
						this.inputData[i].trim() != "" &&
						this.inputData[i].trim().length > this.fieldVal.limit
					) {
						this.errorStatesLen[i] = true;
						this.triggerLinkValid = true;
						this.errorStates[i] = false;
					} else {
						this.errorStates[i] = false;
						this.errorStatesLen[i] = false;
					}
				}
			}
		},
		handleInput(ind) {
			this.currentIndex = ind;
			if (this.id === "portfolio") {
				const urlPattern =
					/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
				if (
					this.inputData[ind].trim() != "" &&
					!urlPattern.test(this.inputData[ind].trim())
				) {
					this.errorStates[ind] =
						this.inputData[ind].trim() != "" &&
						!urlPattern.test(this.inputData[ind].trim());
					this.triggerLinkValid = true;
					this.errorStatesLen[ind] = false;
				} else if (
					this.inputData[ind].trim() != "" &&
					this.inputData[ind].trim().length > this.fieldVal.limit
				) {
					this.triggerLinkValid = true;
					this.errorStatesLen[ind] =
						this.inputData[ind].trim() != "" &&
						this.inputData[ind].trim().length > this.fieldVal.limit;
					this.errorStates[ind] = false;
				} else {
					this.triggerLinkValid = false;
				}
			} else if (this.id === "highlight" || this.id === "responsibility") {
				this.errorStates[ind] =
					(this.inputData[ind].trim() != "" &&
						this.inputData[ind].trim().length > this.fieldVal.limit) ||
					(this.mandatory &&
						this.inputData[ind].trim() == "" &&
						this.inputData.every((value) => value === ""));
			}
			this.$emit("select-value", this.inputData);
			this.$emit("handle-input");
		},
		handleHighInput(ind) {
			this.currentIndex = ind;
			if (this.id === "portfolio") {
				const urlPattern =
					/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
				if (
					this.inputData[ind].trim() != "" &&
					!urlPattern.test(this.inputData[ind].trim())
				) {
					this.errorStatesLen[ind] = false;
					this.errorStates[ind] =
						this.inputData[ind].trim() != "" &&
						!urlPattern.test(this.inputData[ind].trim());
					this.triggerLinkValid = true;
				} else if (
					this.inputData[ind].trim() != "" &&
					this.inputData[ind].trim().length > this.fieldVal.limit
				) {
					this.triggerLinkValid = true;
					this.errorStatesLen[ind] =
						this.inputData[ind].trim() != "" &&
						this.inputData[ind].trim().length > this.fieldVal.limit;
					this.errorStates[ind] = false;
				} else {
					this.triggerLinkValid = false;
				}
			} else if (this.id === "highlight" || this.id === "responsibility") {
				this.errorStates[ind] =
					this.inputData[ind].trim() != "" &&
					this.inputData[ind].trim().length > this.fieldVal.limit;
			}
			this.$emit("select-value", this.inputData);
		},
		addInput() {
			if (this.id === "portfolio" && this.inputData.length >= 8) {
				return;
			}
			this.inputData.push("");
			this.errorStates.push(false);
			this.errorStatesLen.push(false);
		},
		removeInput(index) {
			this.inputData.splice(index, 1);
			this.errorStates.splice(index, 1);
			this.errorStatesLen.splice(index, 1);
		},
	},
};
</script>

<style>
.multi-flex .form-control {
	width: 95%;
}
.mul-grey-txt {
	font-family: "Inter", sans-serif;
	font-size: 13px;
	font-weight: 400;
	color: #667085;
}
.mul-input-height {
	height: 38px !important;
}
.error {
	border: 1px solid #eb0002;
}
@media (min-width: 1029px) {
	.multi-flex {
		display: flex;
		justify-content: space-between;
		width: 100%;
	}
}

.asp-topic {
	font-size: var(--size-10);
}
</style>
